// This plugin handles the calls for product recommendations.
export default function ({ app, $config, route, store, $integrationsManager }) {
    // When app loads client side, trigger api hit to get recommendations.
    $integrationsManager.loaders.onNuxtReadyLoader(() => {
        store.dispatch('recommendations/getRecommendations', getOptions(route))
    })

    // After every route change, update recommendations.
    app.router.afterEach((to, from) => {
        // We only want to fetch results if from exists OR we are not on the same path.
        if (from.name && to.path !== from.path)
            store.dispatch('recommendations/getRecommendations', getOptions(to))
    })

    function getOptions(route) {
        /**
         * Valid Recommendation types
         * recent
         * similar
         * related
         * recommended
         */
        // 'recent' should be on every rec call.
        const options = {
            types: ['recent'],
        }
        // 'recommended' should be on every rec call if its enabled.
        if ($config.runtime.theme.enableRecommendedProducts) options.types.push('recommended')

        if (['product-mmy', 'product', 'sku'].includes(route.name)) {
            options.types.push('similar', 'related')
            options.productLineSlug = route.params.productLine
        }

        return options
    }
}
